/**
 * The bags and boxes a product option can ship in - keys as stored in the
 * database (product_options.packing_size, market_transhipper_markups). Each
 * market has a transhipper markup for each size, the same for every vendor in
 * it (set in the admin portal), and choosing an option's size fills its markup
 * in from there. Same list as
 * admin-backend's config/packing-sizes.ts.
 */
export const PACKING_SIZES = [
  { key: "mini", label: "Mini bag (betta, guppy, cory)" },
  { key: "bag10", label: "10 cm bag" },
  { key: "bag15", label: "15 cm bag" },
  { key: "bag20", label: "20 cm bag" },
  { key: "bag25", label: "25 cm bag" },
  { key: "bag30", label: "30 cm bag" },
  { key: "bag35", label: "35 cm bag" },
  { key: "bag40", label: "40 cm bag" },
  { key: "bag45", label: "45 cm bag" },
  { key: "bag50", label: "50 cm bag" },
  { key: "box_small", label: "Small box (10 kg)" },
  { key: "box_medium", label: "Medium box (16 kg)" },
  { key: "box_large", label: "Large box (22 kg)" },
  { key: "box_jumbo", label: "Jumbo box (25 kg)" },
] as const;

export type PackingSize = (typeof PACKING_SIZES)[number]["key"];

/** A market's markups: {"mini": 2, "bag10": 3, ...}. */
export type SizeMarkups = Partial<Record<PackingSize, number>>;

/** "No Transhipment": no bag or box. Its markup is the market's own "na" value. */
export const NOT_APPLICABLE = "na";

/** A product option's size choices: No Transhipment first, then the sizes. */
export const OPTION_PACKING_SIZES: readonly { key: string; label: string }[] = [
  { key: NOT_APPLICABLE, label: "No Transhipment" },
  ...PACKING_SIZES,
];
